module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Pillar-Page-Resource.2c6aa056.jpg";